import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { useLanguage } from '@/i18n/LanguageContext';

import { API } from '@/lib/apiBase';

export const PhotoEditDialog = ({
  editPhoto, onClose,
  editData, setEditData,
  students, onSave,
  onToggleStudent,
}) => {
  const { t } = useLanguage();
  if (!editPhoto) return null;
  const classStudents = students.filter((s) => s.class_id === editPhoto.class_id);

  return (
    <Dialog open={!!editPhoto} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="bg-card border-border max-w-md">
        <DialogHeader>
          <DialogTitle>{t('admin.editPhoto')}</DialogTitle>
          <DialogDescription className="sr-only">
            {t('admin.editPhoto')}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <div className="aspect-video relative rounded-lg overflow-hidden bg-muted">
            <img
              src={`${API}/photos/${editPhoto.photo_id}/preview`}
              alt={t('common.photoAlt')}
              className="w-full h-full object-contain"
            />
          </div>

          <div className="flex items-center space-x-2">
            <Checkbox
              id="edit_is_class_photo"
              checked={editData.is_class_photo}
              onCheckedChange={(checked) => setEditData({
                ...editData,
                is_class_photo: checked,
                student_ids: checked ? [] : editData.student_ids,
              })}
            />
            <Label htmlFor="edit_is_class_photo" className="cursor-pointer text-sm">
              {t('admin.isClassPhoto')}
            </Label>
          </div>

          {!editData.is_class_photo && (
            <div>
              <Label className="text-sm mb-2 block">{t('admin.assignToStudent')}</Label>
              <div className="max-h-40 overflow-y-auto space-y-1 border border-border rounded-md p-2">
                {classStudents.map((student) => (
                  <div key={student.student_id} className="flex items-center space-x-2 py-1">
                    <Checkbox
                      id={`edit_student_${student.student_id}`}
                      checked={editData.student_ids.includes(student.student_id)}
                      onCheckedChange={() => onToggleStudent(student.student_id)}
                    />
                    <Label htmlFor={`edit_student_${student.student_id}`} className="cursor-pointer text-sm">
                      {student.name}
                    </Label>
                  </div>
                ))}
                {classStudents.length === 0 && (
                  <p className="text-xs text-muted-foreground italic py-2">{t('admin.noStudentsInClass')}</p>
                )}
              </div>
            </div>
          )}

          <div>
            <Label className="text-sm">{t('admin.price')}</Label>
            <Input
              type="number" step="0.50" min="0"
              value={editData.price}
              onChange={(e) => setEditData({ ...editData, price: parseFloat(e.target.value) || 0 })}
              className="bg-secondary border-border mt-1"
              data-testid="edit-photo-price"
            />
          </div>

          <div className="flex gap-3 pt-2">
            <Button onClick={onSave} className="flex-1 bg-primary hover:bg-primary/90" data-testid="save-photo-edit-btn">
              {t('common.save')}
            </Button>
            <Button variant="outline" onClick={onClose} className="flex-1">
              {t('common.cancel')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
